import React, {useEffect, useState} from 'react';
import {getStateByPath} from "../../../../redux/selectors";
import {connect, useSelector} from "react-redux";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {
    ADD_STATE, REMOVE_STATE,
    setFilter,
    setForm,
    setItem, setLoading,
    setTableParams,
    setViewMode
} from "../../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {moduleUdnService} from "../../../../jwt/_services/configuration/moduleUdnService";
import {Col, Row, Spinner} from "reactstrap";
import CustomSwitch from "../../../../components/customSwitch/CustomSwitch";
import {udnService} from "../../../../jwt/_services";

const ModuleUdnSection = (props) => {
    const path = props?.path + '/udn';
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {  domainObject } = parentComponentState?.data || {};
    const {  listDomainObjects } = componentState?.data || [];
    const {  loading } = componentState?.data || {};

    const [options, setOptions] = useState([]);
    const [combinedList, setCombinedList] = useState([]);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        udnService.getOptions( {}).then((options) => {
            setOptions(options.data);
        });

        const dataRequest = {
            id: domainObject.id
        };

        genericIndexedActions.search(path, moduleUdnService, 0, 1000, dataRequest)
    }, []);

    useEffect(() => {
        if (options.length > 0 && listDomainObjects) {
            mapOptionsToSelection();
        }
    }, [options, listDomainObjects]);

    const mapOptionsToSelection = () => {
        const _selection = options.map(option => {

            const udnInList = listDomainObjects.find(it => it.udn.id === option.id);

            if (udnInList) {
                return { ...udnInList, status: true};
            } else
                return { udn: option, module: { id: domainObject?.id }, status: false };
        });

        setCombinedList(_selection);
    }

    const setStatus = (selectedOption) => {
        const dataRequest = {
            id: selectedOption?.id,
            udn: {id: selectedOption?.udn?.id},
            module: {id: selectedOption?.module?.id}
        };

        if (!selectedOption?.status) {
            // Agregar
            genericIndexedActions.add(path, moduleUdnService, dataRequest)
        } else {
            // Remover
            genericIndexedActions.remove(path, moduleUdnService, dataRequest)
        }
    }

    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let dataRequest = {
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        console.log(dataRequest);
        return;
        //genericIndexedActions.reorder(path, activityService, dataRequest)
    }

    const renderContent = (_option, index) => {
        const lbl = _option?.udn?.code || ''
        return (
            <CustomSwitch
                onClick={_ => setStatus(_option)}
                label={ lbl?.toUpperCase().replace('_', ' ') }
                checked={ _option?.status }
            />
        )
    }

    const getSortedList = (list) => {
        return list?.sort((a, b) => {
            if (a?.status === b.status) {
                return a?.code?.localeCompare(b?.code);
            }
            return a?.status ? -1 : 1;
        });
    }

    return (<>
        {
            loading ? <Spinner animation="border"/> : <>
                <div className={'sub-category-section-activities'}>
                    <Row>
                        <h2>{'. Unidades de negocio'}</h2>
                    </Row>
                    <Row>
                        {
                            combinedList?.length > 0 &&
                            <DragDropList
                                items={getSortedList(combinedList)}
                                renderContent={renderContent}
                                onReorder={onReorder}
                                orientationHV={'ruby-text-container'} // Opciones : ruby-text-container, vertical-container, horizontal-container
                                className={'sub-category-section-list'}
                            />
                        }
                    </Row>
                </div>
            </>
        }
    </>)
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(ModuleUdnSection)